import React, { useState, useEffect } from 'react';
import { Header, Home, About, Project } from './components';
import useDarkTheme from './components/useDarkTheme';

import './style/include.scss';

function App() {
  // System Dark Theme
  let darkMode = useDarkTheme();
  // User select mode
  let storeDarkMode = JSON.parse(localStorage.getItem('darkMode'));
  const [isDark, setIsDark] = useState(storeDarkMode ?? false);

  useEffect(() => {
    /* (1st condition) select system or user theme ->
        -- both are false or null respective then null or 
        -- system true, check User mode false
      (2nd condition) check Nullish value if not apply to user mode
    */
    let mode = (darkMode || storeDarkMode) && (storeDarkMode ?? darkMode);
    setIsDark(mode);
  }, [darkMode, storeDarkMode]);

  const onModeToggle = (isDark) => {
    window.localStorage.setItem('darkMode', `${isDark}`);
    setIsDark(isDark);
  };

  let dark = isDark ? 'dark' : '';

  return (
    <div className={`container ${dark}`}>
      <Header isDark={isDark} setDarkMode={onModeToggle} />
      <Home />
      <About />
      <Project />
    </div>
  );
}

export default App;
